function getStartDate(dateStr: string) {
  const [year, month, day] = dateStr.split('-').map(Number)

  if (isNaN(year) || isNaN(month) || isNaN(day)) {
    return new Date()
  }

  return new Date(year, month - 1, day)
}

export default getStartDate
